import { Route } from "react-router-dom";

import { CREATE_ROLE, EDIT_ROLE, VIEW_ROLE, VIEW_USER } from "src/constants";
import { ADMINISTRATION_ROUTES } from "src/pages/administration/constants";
import { ProtectedRoute } from "src/utils/ProtectedRoute";

import { AddEditRole } from "./AddEditRole.page";
import { Administration } from "./Administration.page";
import { SingleUser } from "./SingleUser.page";

/** Route tree for the administration module, mounted under `/administration` and `/user`. */
export const administrationRoutes = (
  <>
    <Route
      path={ADMINISTRATION_ROUTES.root}
      element={<ProtectedRoute permissions={[VIEW_USER, VIEW_ROLE]} component={Administration} />}
    />
    <Route
      path={ADMINISTRATION_ROUTES.addRole}
      element={<ProtectedRoute permissions={CREATE_ROLE} component={AddEditRole} />}
    />
    <Route
      path={ADMINISTRATION_ROUTES.editRole}
      element={<ProtectedRoute permissions={EDIT_ROLE} component={AddEditRole} />}
    />
    <Route
      path={ADMINISTRATION_ROUTES.userDetails}
      element={<ProtectedRoute permissions={VIEW_USER} component={SingleUser} />}
    />
  </>
);
